import { useSelector } from "react-redux";
import { selectSessionProfile, selectUserProfile } from "../redux/profileSlice";

export const useProfiles = () => {
  const sessionProfile = useSelector(selectSessionProfile);
  const userProfile = useSelector(selectUserProfile);
  return { sessionProfile, userProfile };
};

